var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAltArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.978,
    height: 20.86,
    viewBox: "0 0 27.978 20.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1550.784,3795.807l-.591.579a.7.7,0,0,0-.079.9l5.353,7.461-21.772.205a.71.71,0,0,0-.7.71v.745a.71.71,0,0,0,.7.71l21.772.2-5.353,7.46a.7.7,0,0,0,.079.905l.591.579a.7.7,0,0,0,.994-.02l8.869-9.4a1.189,1.189,0,0,0,0-1.63l-8.869-9.4A.7.7,0,0,0-1550.784,3795.807Z",
    transform: "translate(1568.576 -3795.608)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltArrowRightIcon);
export default __webpack_public_path__ + "static/media/alt-arrow-right-icon.b7f1d217ccbb221aa1e2969b9d173530.svg";
export { ForwardRef as ReactComponent };